import React from "react";
import { Actor, AppointmentStatus } from "@/models/club";
import { formatClock } from "./helper/timeGrid";
import { EventItemProps } from "./types";

function EventItemComponent({ setSelectedEvent, event, onEventClick, style, view }: EventItemProps & { style?: React.CSSProperties }) {
  const start = formatClock(event.startTime);
  const end = formatClock(event.endTime);
  const customer = [event.customerFirstName, event.customerLastName].filter(Boolean).join(" ") || event.customerMobileNumber || "";
  const cancelled = event.status === AppointmentStatus.Value2;
  const unpaid = event.status === AppointmentStatus.Value0 && event.actor === Actor.Value20;
  const byCustomer = event.actor === Actor.Value10;
  const status = cancelled ? "کنسل شده" : unpaid ? "پرداخت نشده" : "";
  return (
    <div className="calendar-event-frame" data-view={view} style={style}>
      <button type="button" className="calendar-event" data-view={view} data-cancelled={cancelled || undefined} data-unpaid={unpaid || undefined}
        style={{ "--event-color": event.merchantUserColor || "var(--mantine-primary-color-filled)" } as React.CSSProperties}
        title={[customer, event.merchantServiceTitle, start + " – " + end, status, byCustomer ? "ثبت توسط مشتری" : ""].filter(Boolean).join(" | ")}
        onClick={(e) => { e.stopPropagation(); setSelectedEvent?.(event); onEventClick?.(event); }}>
        <span className="calendar-event-name">{customer}</span>
        <span className="calendar-event-meta">
          {byCustomer && <span className="calendar-event-source" aria-label="ثبت توسط مشتری" />}
          <time>{start}<span className="calendar-event-end"> – {end}</span></time>
        </span>
        {view !== "month" && event.merchantServiceTitle ? <span className="calendar-event-service">{event.merchantServiceTitle}</span> : null}
        {status ? <span className="calendar-event-status">{status}</span> : null}
      </button>
    </div>
  );
}
export const EventItem = React.memo(EventItemComponent);
